<template>
  <div>
    <div id="content">
      <!-- Your content to be converted to PDF goes here -->
      <h1>Hello, PDF!</h1>
      <p>This will be captured and sent to the server as a PDF.</p>
      <v-img src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" width="100px"/>
      <img ref="image" :src="imageSrc" alt="Example Image" @load="onImageLoad" width="100px"/>
      <p>This will be captured and sent to the server as a PDF.</p>
      <!-- <v-img src="https://wws-schoolerp.s3.ap-south-1.amazonaws.com/logo/wws_logo.png" alt="Example Image" @load="onImageLoad" width="100px"/> -->
    </div>
    <button @click="generatePDF">Generate PDF</button>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import axios from 'axios';

export default {
  data() {
    return {
      imageSrc: 'https://wws-schoolerp.s3.ap-south-1.amazonaws.com/logo/wws_logo.png', // Ensure this is an accessible URL
      isImageLoaded: false
    };
  },
  methods: {
    onImageLoad() {
      this.isImageLoaded = true;
    },
    async generatePDF() {
      try {
        // Capture the HTML content as a canvas
        const content = document.getElementById('content');
        // const canvas = await html2canvas(content);
        const canvas = await html2canvas(content, {
          scale: 2,  // Increase the scale for better quality
          allowTaint : true,logging: true ,
          useCORS: true  // Enable CORS to handle images from other origins
        });
        const imgData = canvas.toDataURL('image/png');

        // Create a PDF document
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

        pdf.save('document.pdf');

        // // Convert PDF to Blob
        // const pdfBlob = pdf.output('blob');

        // // Send the PDF to the server
        // const formData = new FormData();
        // formData.append('file', pdfBlob, 'document.pdf');\\\\\\
        // await axios.post('tryNError/plugintestapi', formData, {
        //   headers: {
        //     'Content-Type': 'multipart/form-data'
        //   }
        // });

        // alert('PDF sent to server successfully!');
      } catch (error) {
        console.error('Error generating PDF:', error);
      }
    }
  }
};
</script>
